<app-nav-bar/>


<section class="py-5 text-center container">
  <div class="row py-lg-5">
    <div class="col-lg-6 col-md-8 mx-auto">
      <h1 class="display-5 fw-bold" style="color: var(--secondary-color);">Acciones que generan grandes sonrisas</h1>
<!--      <h3 class="fs-3 fw-bold" style="color: var(&#45;&#45;primary-color);"></h3>-->
      <p class="lead text-secondary">En Grupo Medilink, estamos comprometidos con el bienestar de nuestra comunidad. A través de nuestro programa Risitas Azules, colaboramos con la Fundación Resplandece para brindar chequeos médicos anuales, consultas odontológicas gratuitas y actividades especiales para los niños.</p>
      <div class="container mx-0" >
        <img src="assets/img/responsabilidadSocial/risitasAzules.png" style="width: 80%" alt="">
      </div>
    </div>
  </div>
</section>

<div class="album py-5 bg-body-tertiary">
  <div class="container">

    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
      <div class="col" *ngFor="let fotos of fotosResponsabilitySocial">
        <div class="card shadow-sm" >
          <img src="assets/img/responsabilidadSocial/{{fotos.nameImagen}}" alt="" class="bd-placeholder-img card-img-top" width="100%" height="225"
               (click)="openModal(fotos.nameImagen)"
          style="cursor: pointer;">
<!--          <svg class="bd-placeholder-img card-img-top" width="100%" height="225" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: Thumbnail" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#55595c"/><text x="50%" y="50%" fill="#eceeef" dy=".3em">Thumbnail</text></svg>-->

          <!--<div class="card-body">
&lt;!&ndash;            <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>&ndash;&gt;
            <div class="d-flex justify-content-between align-items-center">
              &lt;!&ndash;<div class="btn-group">
                <button type="button" class="btn btn-sm btn-outline-secondary">View</button>
                <button type="button" class="btn btn-sm btn-outline-secondary">Edit</button>
              </div>&ndash;&gt;
            </div>
          </div>-->
        </div>
      </div>


    </div>
  </div>
</div>

<div
  class="modal fade"
  id="imageModal"
  tabindex="-1"
  aria-labelledby="imageModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body text-center">
        <img
          [src]="'assets/img/responsabilidadSocial/' + selectedImage"
          alt=""
          class="img-fluid"
        />
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn buttonAction  "
          data-bs-dismiss="modal"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>

<app-footer-persona/>
